import { render, staticRenderFns } from "./VendorBadanUsahaBCE.vue?vue&type=template&id=85fb67cc&"
import script from "./VendorBadanUsahaBCE.vue?vue&type=script&lang=js&"
export * from "./VendorBadanUsahaBCE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports